import React, { useEffect, useState } from 'react';

function ContentMastering(props) {
    return (
        <div>
            <div className="recruit_contents">
                <div className="recruit_titleline_w">
                    <h4 className="recruit_titleline_info">미디어엔지니어</h4>
                    <h5 className="recruit_titleline_title">콘텐츠마스터링</h5>
                </div>
                <div className="recruit_subtitleline_w">
                    <h6 className="recruit_titleline_info">직무소개</h6>
                </div>
                <div className="recruit_cont">
                    <p className="recruit_subinfo_text">
                        종합편집담당자는 SBS 콘텐츠를 완성하는 업무를 수행합니다.<br />
                        여러 과정을 거쳐온 결과물을 최종적으로 완성해서 방송에 내보낼 수 있게 만듭니다. 구체적으로 얘기하자면 종합편집실이라는 공간에서<br />
                        비디오 및 오디오에 대한 안목을 바탕으로 적절한 소프트웨어 및 하드웨어를 활용하여 콘텐츠를 방송 규격에 맞게 완성합니다.<br />
                        종합편집실에는 콘텐츠를 기술적으로 분석하는 계측 장비부터, 제작 및 완성하는 데 필요한 편집 장비, 자막 장비 및 레코딩 서버,<br />
                        오디오 믹서 등 다양한 장비들이 있습니다. 여러 장비들을 활용하여야 하므로 아래와 같은 역량이 갖춰져 있으면 많은 도움이 됩니다.
                    </p>
                    <ul className="recruit_subinfo_list">
                        <li className="recruit_subinfo_list_inner">비디오 및 오디오 신호에 대한 이해</li>
                        <li className="recruit_subinfo_list_inner">카메라에 대한 기초 지식</li>
                        <li className="recruit_subinfo_list_inner">영상 편집 프로그램 활용 능력</li>
                        <li className="recruit_subinfo_list_inner">커뮤니케이션 및 문제 해결 역량</li>
                        <li className="recruit_subinfo_list_inner">동영상 포맷에 대한 기본 지식</li>
                        <li className="recruit_subinfo_list_inner">오디오 믹서 운용 능력</li>
                    </ul>
                    <p className="recruit_subinfo_text">
                        앞서 언급된 역량은 미리 갖출수록 좋지만, 개인이 준비하기에는 약간 막연하다는 생각을 하실 수도 있습니다. 부담은 최대한 내려놓고,<br />
                        반드시 필요한 기본 지식에 중점을 두시면 좋습니다. 실제 업무를 담당하게 되었을 때, 배우면서 나날이 발전시켜나가야 합니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">부서 소개</h7>
                    <p className="recruit_subinfo_text">
                        콘텐츠마스터링팀은 인제스트, 색 보정, 사운드 디자인, 종합편집 등으로 구성되어 있습니다.
                    </p>
                    <em className="recruit_bold_text">종합편집</em>
                    <p className="recruit_subinfo_text">
                        UHD/HD 방송용 최종본 마스터링을 합니다. 방송 포맷에 맞도록 콘텐츠를 가공하며,
                        콘텐츠의 비디오 및 오디오 이슈를 해결하고<br />향상시킵니다. 항상 콘텐츠 제작의 전반적인 워크플로우를 개선하려고 합니다.
                        최근에는 타 플랫폼 간 콘텐츠 교류도 활발해져서,<br />종합편집이 완료된 콘텐츠에 대한 관리도 철저히 하고 있습니다.
                    </p>
                    <em className="recruit_bold_text">인제스트</em>
                    <p className="recruit_subinfo_text">
                        교양, 예능 프로그램의 촬영 원본을 편집이 원활하게 되도록 변환하고 정리하여 저장하는 곳입니다.<br />
                        점점 촬영 카메라 대수 및 높은 해상도의 촬영이 많아지는 추세여서 파일 변환 및 관리의 중요성은 커지고 있습니다.
                    </p>
                    <em className="recruit_bold_text">색 보정</em>
                    <p className="recruit_subinfo_text">
                        색 보정실에서는 우선적으로 다수의 카메라로 촬영한 컷들의 컬러 톤을 균일하게 맞춰 영상의 연속성이 끊어지지 않게 합니다.<br />
                        추가적으로 연출 의도를 살리기 위해 다양한 방식으로 감각적인 작업을 합니다.
                    </p>
                    <em className="recruit_bold_text">사운드 디자인</em>
                    <p className="recruit_subinfo_text">
                        스포츠 빅이벤트, 연말 시상식, 가요 대전 등 주요 생방송의 오디오 품질을 관리합니다.<br />
                        또한 촬영본의 현장음이 균일하지 않은 경우, 노말라이징 작업도 하고 있습니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                    <p className="recruit_subinfo_text">
                        SBS라는 타이틀을 달고 콘텐츠가 제작되고 방송되기까지 무수히 많은 방송인들의 손을 거쳐 갑니다.<br />
                        그 수많은 노력과 결실이 깃든 최종적인 결과물이 콘텐츠마스터링팀에서 만들어집니다.
                        콘텐츠마스터링팀에서 종합편집 업무를 하게 된다면, 먼저 콘텐츠의 모든 것을 알아야만 하고 알게 됩니다.
                        비디오 신호와 오디오 신호에 대한 기술적인 이해부터 이를 다루는 소프트웨어 및<br />하드웨어를 익히게 됩니다.
                        또한, 콘텐츠 제작의 전체적인 워크플로우를 자연스레 알게 됩니다. 그래야지만 콘텐츠가 제작되는 여러 단계에서 발생할 수 있는
                        기술적인 문제를 여러 부서의 사람들과 소통을 하여 해결할 수 있게 됩니다.<br />
                        <br />
                        콘텐츠는 촬영 단계에서부터 최종본이 송출되기까지 정말 다양한 상황들이 발생할 수 있기 때문에
                        종합편집실에서 마스터링하는 과정에서<br />수많은 경우를 맞닥뜨리게 됩니다.
                        모든 경우를 하나하나 기술적으로 해결해 나가다 보면 어느새 콘텐츠 제작의 큰 그림이 머릿속에 그려지게 될 것입니다.
                        이는 콘텐츠의 중요성이 날이 갈수록 커지는 만큼, 대체 불가능한 역량으로 다가올 것입니다.
                    </p>
                </div>
                <div className="recruit_subtitleline_w">
                    <h6 className="recruit_titleline_info">선배인터뷰</h6>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">본인 소개</h7>
                    <p className="recruit_subinfo_text">
                        안녕하세요 SBS 콘텐츠마스터링팀에서 종합편집을 담당하고 있는 배준경입니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">종합편집 담당자가 된 계기는?</h7>
                    <p className="recruit_subinfo_text">
                        입사 후 처음에는 네트워크기술팀 주조정실 근무를 했습니다.<br />
                        종합편집, 즉 마스터링 작업이 완료된 콘텐츠를 송출하는 업무를 하였습니다.<br />
                        당시에는 안정적으로 송출하는 부분에 업무의 초점을 맞추었는데, 근무하면서도 '주조정실로 전송되는 콘텐츠는
                        어떠한 과정을 거치는 걸까?' 라는 막연한 궁금함이 있었습니다. 그러다 팀 이동을 할 수 있는 좋은 기회가 생겼고,
                        평소 가졌던 궁금증을 해소하고 싶어서 콘텐츠마스터링팀에 가게 되었습니다.
                        현재는 콘텐츠마스터링팀에서 콘텐츠 제작의 완성이라고 할 수 있는 종합편집담당자로 일하고 있습니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                    <p className="recruit_subinfo_text">
                        콘텐츠는 촬영부터 인제스트, 개인편집, 색 보정, 음악 및 효과, 더빙 등 다양한 과정을 거친 후
                        최종적으로 종합편집을 하면<br />방송에 나갈 수 있게 됩니다. 여러 가지 과정을 거쳤지만, 종합편집 단계에서 콘텐츠의 비디오 및 오디오 부분과
                        관련하여 기술적으로<br />개선할 수 있는 부분이 많습니다. 방송에 나가기 직전 콘텐츠를 가장 먼저 접하는 사람으로서,
                        콘텐츠가 종합편집 과정을 거친 후<br />시청자들에게 잘 전달되었다는 것을 확인하였을 때 가장 큰 보람을 느낍니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                    <p className="recruit_subinfo_text">
                        앞서 말씀드리자면, 정말 요즘같이 콘텐츠가 범람하고 있는 시기는 없을 것입니다.<br />
                        무수한 플랫폼과 무수히 쏟아져 나오는 콘텐츠, 레거시 영상부터 숏폼까지, 이러한 환경 속에서
                        사람들은 하루에도 수많은 콘텐츠를<br />소비하고 있습니다.
                        콘텐츠가 무엇보다 중요한 이 순간, SBS는 대 콘텐츠 시대의 중심에 있습니다.
                        다채로운 콘텐츠들을 제작해오면서,<br />과거 30여 년간 쌓인 방송 노하우와 현재 변화에 앞장서겠다는 열망이 공존하고 있습니다.<br />
                        그리고 이러한 SBS의 다양한 콘텐츠는 기술 지원 속에서 지탱되어 왔습니다.<br />
                        <br />
                        아무리 좋은 콘텐츠라도 잘 전달되지 않는다면 의미가 없을 것입니다.
                        좋은 콘텐츠를 제작하기 위해서는 좋은 기술이 반드시 필요합니다.<br />
                        점점 더 커질 콘텐츠의 중요성을 이해하고, 콘텐츠의 근간이 되는 방송 기술에 대한 자부심을 느끼고 싶다면
                        이곳만큼 좋은 곳도 없을<br />것입니다. 기회가 넘쳐나는 이곳에서 마음껏 역량을 펼치세요.<br />
                        콘텐츠마스터링팀은 SBS의 미래를 함께 걸어가실 지원자를 기다립니다.
                    </p>
                </div>
            </div>
            <div className="recruit_contents">
                <div className="recruit_titleline_w">
                    <h4 className="recruit_titleline_info">미디어엔지니어</h4>
                    <h5 className="recruit_titleline_title">네트워크기술</h5>
                </div>
                <div className="recruit_subtitleline_w">
                    <h6 className="recruit_titleline_info">직무소개</h6>
                </div>
                <div className="recruit_cont">
                    <p className="recruit_subinfo_text">
                        신호를 전송할 수 있는 수단은 SNG(위성중계), 광회선(Optical Fiber), MicroWave, 인터넷, MNG(모바일중계) 등 다양합니다.<br />
                        무선 회선인 SNG와 MicroWave는 우천시 전파 감쇄에 취약한 반면 도서 산간지역 중계에 유리합니다.<br />
                        인터넷 회선은 저렴하게 회선을 구성할 수 있으나 안정성을 담보할 수 없습니다. 광회선은 짧은 Delay가 장점이지만
                        통신사의 인프라를<br />임차해야만 합니다. 근래에는 저렴한데다 안정성까지 갖추게 된 MNG 송출 빈도가 늘고 있습니다.<br />
                        <br />
                        NQC에는 이렇게 다양한 회선이 구축되어 있으며 이를 통해 시청자들께 생생한 현장을 전달합니다.<br />
                        필요에 따라 신기술을 도입하기도 하며 새로운 회선을 설계/구축합니다. 따라서, NQC 근무를 위해서는
                        가장 먼저 RF/통신/네트워크이론에<br />대한 이해가 필요합니다. 또한, 통신사와의 회선 임차 계약, 장비제조사와의 협의 등을
                        SBS에 유리한 방향으로 이끌기 위한 소통능력도<br />필요하다 할 수 있습니다. 소통능력은 타 직군 동료들에게 어려운 기술적 내용을 이해시키고
                        그들의 요구와 기술적 한계를 절충하는 데<br />필요한 능력이기도 합니다.<br />
                        <br />
                        필요역량을 정리하자면 아래와 같습니다.
                    </p>
                    <ul className="recruit_subinfo_list">
                        <li className="recruit_subinfo_list_inner">RF/통신/네트워크 이론에 대한 학부 수준의 ‘기본적’ 이해</li>
                        <li className="recruit_subinfo_list_inner">소통 능력</li>
                        <li className="recruit_subinfo_list_inner">변수에 신속히 대응하기 위한 기민함</li>
                    </ul>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">부서 소개</h7>
                    <p className="recruit_subinfo_text">
                        네트워크기술팀은 송신소/TC, 주조정실 그리고 NQC 3파트로 이루어져 있습니다.
                    </p>
                    <em className="recruit_bold_text">송신소/TC(Transmission Control)</em>
                    <p className="recruit_subinfo_text">
                        송신소에서는 수도권 일대 24개 송중계소 유지관리 업무를 담당합니다.<br />
                        HDTV, UHDTV, 파워FM, 러브FM, AM, DMB 6개 매체에 대해 송신기, 안테나, STL/TSL, 철탑, 전력, 공조 설비 등을 관리합니다<br />
                        사내에서 RF 업무를 심도있게 수행할 수 있는 몇 안 되는 곳으로 RF 전문가로 성장할 수 있으며<br />
                        무엇보다 남산 보수 기지에서 근무하게 되면 동료, 선배들과 가족 같은 분위기에서 근무할 수 있습니다.<br />
                        TC는 목동 사옥에서 송중계소를 24시간 원격 모니터링 하며, SBS 홈페이지 및 Wavve에서 라이브 스트리밍하는 SBS 채널도 관제합니다.
                    </p>
                    <em className="recruit_bold_text">주조정실</em>
                    <p className="recruit_subinfo_text">
                        시청자가 보는 SBS 6번 채널 화면이 최종적으로 송출되는 곳입니다.<br />
                        주조정실에서는 자동편성시스템(AIMS)에 작성된 편성표에 따라 프로그램들이 순차적으로 송출되며,
                        이와 관련된 서버와 장비들을 관리하고 장애에 대응하는 역할을 합니다. 또한, 국민안전과 직결되는 재난상황 자막을 표출하고 뉴스 특보 등 급박한 상황에서도 방송이 유연하게<br />
                        흘러가도록 조치하는 SBS의 최종 수문장이라 표현할 수 있습니다.
                    </p>
                    <em className="recruit_bold_text">NQC</em>
                    <p className="recruit_subinfo_text">
                        올림픽, 월드컵 같은 국제 스포츠 행사나 대선, 총선 등 공직 선거가 있으면 방송사에서는 이를 생중계합니다.<br />
                        생중계를 위해서는 여러 현장의 영상 소스들이 안정적으로 목동 사옥으로 전송되어야 하며,<br />
                        이렇게 전송된 소스들이 사옥 내 제작시설(부조정실, 옵튜브룸, 편집실 등)로 분배되어야 합니다.<br />
                        이 과정에서 NQC는 외부 중계 현장들과 사내 제작시설들을 이어주는 방송신호의 허브 역할을 한다고 보면 됩니다.<br />
                        회선사업자/회선종류/장비/수량을 선정하고 각종 중계회선을 구성하는 과정을 주도하게 됩니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                    <p className="recruit_subinfo_text">
                        NQC에서 근무하게 되면 전송기술 트렌드를 눈으로 보고 체험할 수 있습니다.<br />
                        몇 년 전까지만 해도 생중계를 위해선 중계차가 출동해, 케이블을 끌고 카메라를 세팅하고 통신사 직원들과 회선을 구축하는 일련의 과정을<br />
                        거쳐야 했습니다. 그러나 현재 이동통신기술의 발달로(LTE → 5G) 카메라와 백팩형 MNG 장비만 메고 출동하면 LTE가 터지는 국내외<br />
                        어떤 장소에서도 무선 중계가 가능하게 되었습니다.
                        또한, 네트워크 기술의 발달로 public 인터넷망을 사용하더라도 해외로부터 양질의<br />신호를 받을 수 있는 환경이 되었습니다.
                        또한, NQC는 방송국 외부와 내부를 이어주는 허브 역할을 하며 사내 다양한 제작부서,<br />
                        직군과 협업하기 때문에 다른 어떠한 부서를 가더라도 NQC에서의 경험이 시너지 효과를 낼 수 있다고 봅니다.
                    </p>
                </div>
                <div className="recruit_subtitleline_w">
                    <h6 className="recruit_titleline_info">선배인터뷰</h6>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">본인 소개</h7>
                    <p className="recruit_subinfo_text">
                        안녕하세요. SBS 네트워크기술팀에서 회선관리(Network Quality Control)를 담당하고 있는 오주봉이라 합니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">회선 담당자가 된 계기는?</h7>
                    <p className="recruit_subinfo_text">
                        입사 후 맡은 첫 업무는 전파 행정 및 대관 업무였습니다.<br />
                        SBS가 사용하는 전파에 대해 정부로부터 허가를 받는 일 그리고 정부에서 추진하는 기술 관련 정책에 대해 SBS의 이익에 부합하는지<br />검토하고 대응하는 일이었습니다.
                        업무를 5년 정도 하던 중 순환근무 제안을 받았고, 그간 해왔던 행정 업무와는 다른 성격의 일도 해보고<br />싶다고 말씀드렸습니다.
                        여러 여건이 맞아 NQC 업무를 시작하게 되었습니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                    <p className="recruit_subinfo_text">
                        이번 제20대 대선의 경우 최다 회선을 구축했던 중계였는데, 후보 단일화로 인해 선거 전날까지도 회선 내역이 변경/추가되었습니다.<br />
                        보통 이렇게 규모가 큰 중계 방송의 경우 리허설을 여러 차례 실시하고 회선 구축/안정화에 장시간 기술적 노력을 기울입니다.<br />
                        하지만 정치적 변수에 따라 방송이 임박한 상황에서 시스템이 변경되기도 하고 예상치 못한 장애가 발생하기도 합니다.<br />
                        초긴장 상태가 장시간 유지되지만, 방송이 끝나고 올라가는 엔딩 크레딧에서 제 이름을 볼 때의 보람은 참으로 값지다고 생각합니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                    <p className="recruit_subinfo_text">
                        안정성을 중시하는 방송국 업무 특성상 신기술 도입에 많은 시간이 필요합니다. 방송국 내부에서 돌아다니는 주 신호는 SDI 신호로 아직<br />단방향 신호입니다.
                        그러나 이제는 기술 도입의 변곡점에 거의 도달하였고 많은 부분 IP신호로 대체되고 있습니다.<br />
                        앞으로 더 다양한 곳에서 더 많은 사람들이 SBS의 콘텐츠를 즐기게 될 것입니다.
                        풍부한 IT 지식을 바탕으로 변화의 시대에 SBS가 어떠한<br />길을 가야할지 함께 고민할 지원자분들을 환영합니다.
                    </p>
                </div>
            </div>
            <div className="recruit_contents">
                <div className="recruit_titleline_w">
                    <h4 className="recruit_titleline_info">미디어엔지니어</h4>
                    <h5 className="recruit_titleline_title">라디오기술</h5>
                </div>
                <div className="recruit_subtitleline_w">
                    <h6 className="recruit_titleline_info">직무소개</h6>
                </div>
                <div className="recruit_cont">
                    <p className="recruit_subinfo_text">
                        라디오 엔지니어는 라디오 방송을 이끄는 선장과 같은 역할을 합니다.<br />
                        따라서 라디오 방송을 제작하는 음향 감독은 오디오 시그널 플로우에 대한 이해를 하는 것이 가장 중요합니다.<br />
                        오디오 입력부터 출력까지의 모든 부분을 알고 있어야 예기치 못한 문제 발생 시 쉽게 대처할 수 있기 때문입니다.<br />
                        또한, 기본적으로 라디오라는 전파 매체에 대한 이해, 최근 많이 진행하는 보는 라디오 디지털 송출과 관련된
                        비디오 시그널에 대한 이해,<br />IT 네트워크 지식도 필요합니다. 그 밖에도 라디오 엔지니어는 제작진, 출연자 등
                        다양한 사람들의 의견을 조율하는 구심점이 되어야 하기<br />때문에 커뮤니케이션 능력이 필요합니다.<br />
                        <br />
                        필요 역량을 몇 가지로 요약해 보자면 아래와 같습니다.
                    </p>
                    <ul className="recruit_subinfo_list">
                        <li className="recruit_subinfo_list_inner">오디오, 비디오 시그널 플로우에 대한 이해</li>
                        <li className="recruit_subinfo_list_inner">통신이론에 대한 지식</li>
                        <li className="recruit_subinfo_list_inner">커뮤니케이션 능력</li>
                        <li className="recruit_subinfo_list_inner">돌발 상황에 대처할 수 있는 순발력</li>
                        <li className="recruit_subinfo_list_inner">IT 네트워크 지식</li>
                        <li className="recruit_subinfo_list_inner">라이브 스트리밍 장비와 시스템에 대한 이해</li>
                    </ul>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">부서 소개</h7>
                    <p className="recruit_subinfo_text">
                        라디오기술팀은 크게 네 파트로 구성되어 있습니다.
                    </p>
                    <em className="recruit_bold_text">라디오 제작 파트</em>
                    <p className="recruit_subinfo_text">
                        라디오 방송 제작에 관한 기술적인 모든 부분을 컨트롤합니다.<br />
                        쉽게 말해 SBS Love FM, Power FM 채널의 생방송 스튜디오에서 오디오 콘솔을 만지며 믹싱하는 음향 감독을 생각하시면 됩니다.<br />
                        제작 담당자는 콘솔을 통해 들어오고 나가는 모든 소리들을 컨트롤하여 고품질의 오디오를 청취자들이 감상할 수 있도록 노력합니다.<br />
                        또한, 보는 라디오를 위한 비디오 품질도 함께 관리하고 있습니다.
                    </p>
                    <em className="recruit_bold_text">라디오 IT 시스템 관리 파트</em>
                    <p className="recruit_subinfo_text">
                        팀 내에서 점차 중요도가 높아지고 있는 파트입니다.<br />
                        라디오 IT 시스템 관리의 주요 업무는 ‘NIKE’라고 불리는 라디오 파일 시스템 관리와 ‘고릴라’ 애플리케이션 송출 관련 시스템 관리가<br />있습니다.
                        라디오 관련 부서들에서 사용하는 네트워크망과 연관된 모든 시스템을 담당하는 파트입니다.
                    </p>
                    <em className="recruit_bold_text">라디오 중계 및 공개방송 파트</em>
                    <p className="recruit_subinfo_text">
                        라디오 중계는 스포츠 생방송 중계와 야외 공개 방송이 있습니다.<br />
                        중계 담당자는 미리 라디오 방송 전용 회선을 신청한 후 현장에 방송장비를 설치하고 목동 SBS까지 무사히 신호가 도착할 수 있도록<br />연결합니다.
                        중계방송을 진행할 때는 청취자들에게 생생한 현장감이 느껴지도록 현장음을 살려 오디오를 믹싱하는 역할을 합니다.
                    </p>
                    <em className="recruit_bold_text">라디오 송출 파트</em>
                    <p className="recruit_subinfo_text">
                        라디오는 TV 주조정실과 별개로 독립적인 라디오 주조정실을 가지고 있습니다.<br />
                        라디오 스튜디오와 57분 교통 방송 제작 현장, 중계방송 현장 등의 다양한 입력들을 받아서 일일방송운행표에 따라 자동으로 프로그램을<br />송출합니다.
                        RF 송출뿐만 아니라 고릴라로 가는 디지털 송출 구간별 모니터링도 함께 하고 있습니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                    <p className="recruit_subinfo_text">
                        저희 팀은 라디오 제작뿐만 아니라 IT 시스템 관리, 중계방송, 송출 관리 등 다양한 일을 하고 있습니다.<br />
                        TV에서는 이와 같은 업무가 각 팀별로 분리되어 있다면, 라디오에서는 저희 팀이 기술 관련 모든 일을 하는 ALL-IN-ONE 부서입니다.<br />
                        따라서 팀 내에서도 다양한 경험을 할 수 있는 기회가 열려 있고, 본인이 원하는 직무를 맡을 수 있습니다.<br />
                        방송국 업무의 시작을 저희 팀에서 하신다면 후에 다른 팀을 가게 되더라도 갚진 경험이 될 것입니다.<br />
                        두 귀와 열정만 가지고 있으시다면 일단 도전하세요!
                    </p>
                </div>
                <div className="recruit_subtitleline_w">
                    <h6 className="recruit_titleline_info">선배인터뷰</h6>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">본인 소개</h7>
                    <p className="recruit_subinfo_text">
                        안녕하세요. SBS 라디오기술팀에서 라디오 엔지니어로 일하고 있는 배민선입니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">라디오 엔지니어가 된 계기는?</h7>
                    <p className="recruit_subinfo_text">
                        저는 입사 후 바로 라디오기술팀으로 발령받아 현재 4년 차 라디오 엔지니어로 일하고 있습니다.<br />
                        SBS는 입사 전형 과정 중에 지원한 직군의 전 부서를 도는 인턴십 과정이 있는데, 이때 경험한 라디오기술팀은 딱 제가 생각했던 방송 일을<br />하는 부서였습니다.
                        오디오 콘솔 앞에 앉아 각종 음향 상태를 체크하고 꽉 찬 소리를 만들어 내는 선배님들을 보며 이 팀에서 일하면 정말<br />재밌을 것 같다는 생각이 들었습니다.
                        그러다 라디오기술팀에 정식으로 발령받아 일할 수 있는 좋은 기회가 생겼고,<br />현재까지 라디오 엔지니어로서 재밌게 일을 하고 있습니다.
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                    <p className="recruit_subinfo_text">
                        가수의 목소리와 악기들이 마이킹 된 소리를 잘 믹싱해서 좋은 라이브 음향이 나왔을 때 가장 보람을 느낍니다.<br />
                        하나의 사운드가 만들어지기 위해서는 마이킹부터 시작해 콘솔에 소리를 입력받아 최종 아웃풋이 나오기까지 수많은 단계가 있습니다.<br />
                        사실 오디오는 굉장히 주관적이라서 정답은 없는데요, 사람마다 자신이 좋아하는 취향의 사운드는 있습니다.<br />
                        예를 들어 누군가는 베이스가 풍성해 심장을 뛰게 하는 소리를 좋아하고, 누군가는 하이 주파수 대역이 살아있는 선명한 소리를 좋아하는<br /> 것처럼요.
                        리버브, 컴프레서, EQ 같은 각종 이펙터를 걸고 이렇게도 해보고 저렇게도 해보면서 최상의 소리가 무엇인지 고민하는 과정이<br />재밌습니다.
                        그 과정을 거쳐 제가 원하던 소리가 나왔을 때의 쾌감은 이루 말할 수 없습니다. (특히나 눈앞에 있는 출연자가 제가 좋아하는<br />가수라면 더더욱요!)
                    </p>
                </div>
                <div className="recruit_cont">
                    <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                    <p className="recruit_subinfo_text">
                        음악 듣는 것을 좋아하시나요? 영상 보는 것을 좋아하시나요?<br />
                        그렇다면 주저하지 말고 SBS에 지원하세요! 현대인의 취미 중 대다수를 차지하는 음악 감상과 TV 시청을 마음껏 하실 수 있답니다.<br />
                        사실 방송국 입사라고 하면 어렵게 생각하시는 분들이 많은데 너무 어렵지 않게 생각하셨으면 좋겠습니다.<br />
                        SBS는 채용 과정이 다소 길어 과연 내가 이걸 통과할 수 있을까? 의구심을 가지는 분들이 많은데요,
                        사람은 어떻게든 다 하게<br />되어있더라고요… 저도 입사지원서를 썼을 때를 생각해 보면 막막하고 두려웠지만,
                        막상 지원한 후에는 생각을 줄이고 물 흐르듯 준비를<br />했던 기억이 납니다. 제가 생각하는 꿀팁 몇 가지를 드리자면,
                        평소 기계를 만질 때 매뉴얼을 보는 습관을 들이셨으면 좋겠습니다.<br />
                        엔지니어는 기본적으로 장비와 친해야 하는데 장비를 잘 알 수 있는 방법은 바로 매뉴얼을 보는 것입니다.<br />
                        그리고 1인 방송을 할 수 있는 기회가 된다면 꼭 해보셨으면 좋겠습니다. 다양한 플랫폼, 소규모 방송 시스템에 대한 이해는
                        방송국에<br />입사해서도 큰 도움이 될 것입니다. 여러분은 SBS에서 ‘덕업일치’의 삶을 사실 수 있습니다. 마음껏 꿈을 펼쳐보세요!
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ContentMastering;